import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

export function postReactivateAccount() {
  return send<unknown>({
    path: '/api/reactivate_account/',
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
    body: {},
  });
}
